import React, { useEffect, useState, useMemo } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'

import ChartDataLabels from 'chartjs-plugin-datalabels'
import { useToasts } from 'react-toast-notifications'
import { Bar } from 'react-chartjs-2'

import { useSelector } from 'react-redux'

import axiosInstance from '../../../../../services/config/AxiosIntance'

import Loader from '../../../../../components/Loader'
import DashboardItemTitle from '../../components/DashboardItemTitle'
import NoData from '../../components/NoData'

import { chartThreeMonthColors } from '../../../../../constant/constant'

// Register chart components and plugins
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
)

const HiredApplicants = () => {
  const filters = useSelector((state) => state.dashboard.filters)
  const { addToast } = useToasts()

  const [loading, setLoading] = useState(false)
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  })

  useEffect(() => {
    setLoading(true)
    const queryParams = new URLSearchParams(filters).toString()

    axiosInstance
      .get(`/dashboard/hired-jobs?${queryParams}`)
      .then((res) => {
        const result = res?.data?.result || { labels: [], datasets: [], total_applicants: 0 }

        const datasets = (result.datasets || []).map((item, index) => {
          const rawData = (item.data || []).map((v) => (v == null ? '' : String(v)))

          // numeric values for bar heights
          const numericData = rawData.map((r) => {
            if (!r) return 0
            return r.split(',').length // number of roles
          })

          return {
            label: item.name,
            data: numericData,
            rawData, // keep titles for tooltips
            backgroundColor: chartThreeMonthColors[index] || chartThreeMonthColors[0],
            borderColor: chartThreeMonthColors[index] || chartThreeMonthColors[0],
            borderWidth: 1,
            barPercentage: 1.0,
            categoryPercentage: 0.8,
          }
        })

        setChartData({
          labels: result.labels || [],
          datasets,
        })
      })
      .catch((err) => {
        addToast(
          err?.response?.message ||
          err?.response?.data?.message ||
          'Internal Server Error',
          {
            appearance: 'error',
            autoDismiss: true,
          }
        )
      })
      .finally(() => {
        setLoading(false)
      })
  }, [filters, addToast])

  const options = useMemo(
    () => ({
      type: 'bar',
      maintainAspectRatio: false,
      plugins: {
        title: {
          color: 'black',
          display: true,
          align: 'start',
          position: 'top',
          text: `Role Status`,
          font: {
            size: 24,
            family: "'Lato', 'sans-serif'",
            weight: 300,
          },
        },
        legend: {
          position: 'top',
        },
        datalabels: {
          // Show number of roles inside the bar
          formatter: (value) => (value > 0 ? `${value}` : ''),
          color: 'black',
          anchor: 'center',
          align: 'center',
          font: { size: 11 },
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              return `${context.dataset.label}: ${context.formattedValue} roles`
            },
          },
        },
      },
      scales: {
        x: {
          stacked: false,
          grid: { display: false },
        },
        y: {
          stacked: false,
          grid: { display: false },
          ticks: {
            precision: 0,
          },
          min: 0,
        },
      },
      responsive: true,
    }),
    [chartData]
  )

  const component = loading ? (
    <Loader />
  ) : chartData.labels && chartData.labels.length && chartData.datasets && chartData.datasets.length ? (
    <Bar options={options} data={chartData} plugins={[ChartDataLabels]} />
  ) : (
    <>
      <DashboardItemTitle title="Role Status" />
      <NoData />
    </>
  )

  return component
}

export default HiredApplicants
